export const API_BASE = 'https://flame-picks-production-api.onrender.com';
